module.exports = "<p>\r\n  Test invitation composant\r\n</p>\r\n"